import { render, staticRenderFns } from "./OnlineContactStage.vue?vue&type=template&id=dcafbd56&scoped=true&"
import script from "./OnlineContactStage.vue?vue&type=script&lang=js&"
export * from "./OnlineContactStage.vue?vue&type=script&lang=js&"
import style0 from "./OnlineContactStage.vue?vue&type=style&index=0&id=dcafbd56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcafbd56",
  null
  
)

export default component.exports